import React from 'react';
import $ from "jquery";
import Server from '../../functions/server';
import Loading from '../loading';
import { Dropdown } from 'semantic-ui-react';
import ReadCookie from '../../functions/readcookies';

class Customer extends React.Component {

  state = {
    customerOption: []
  }

  componentDidMount() {
    this.getBranch();
  }


  getBranch() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Branch'
    })
    $.ajax({
      type: 'POST',
      url: Server() + 'branchdetails/getallbranchs.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
        try {
          data = JSON.parse(data);
          context.setAllBranch(data);
        } catch (e) {
          console.log(e);
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  setAllBranch(data) {
    let context = this;
    var customer = [];
    data.map((y) => {
      let text = y.id+"-->"+y.name;
      customer.push({key: text, text: text, value: y.id});
    });
    if (this.props.type == 'all') {
      customer.push({key: 'ALL', text: 'ALL', value: 'ALL'});
    }
    this.setState({
      branchOption: customer,
      branchs: data
    });
  }

  branch = (f, { value }) => {
    this.setState({ branch: value });
    this.props.update(value, this.state.branchs);
  }
  render() {
    return (
      <div>
        <Dropdown placeholder='Branch' style={{ borderColor: '#5A9CBB' }}
         search selection onChange={this.branch}
         options={this.state.branchOption} value={this.state.branch} />
      </div>
    );
  }
}

export default Customer;
